import SelectorEngine from '../../utils/dom/selector-engine';
// import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import InputField from '../InputField';
// import SelectComponent from '../SelectComponent';

class TournamentEventForm extends FormComponent {
	constructor(element, config) {
		super(element, config);
	}
	markup(value, rowData, titleMarkup) {
		return `
            <div class="lta-tournament-event">
				<div class="lta-tournament-event-title">${titleMarkup}</div>
                <div class="lta-tournament-event--form u-mb-2">
                    <div class="lta-tournament-event--mini-days u-mb-3"></div>
                    <div class="lta-tournament-event--junior-days u-mb-3"></div>
					<div class="lta-tournament-event--open-days u-mb-3"></div>
					<div class="lta-tournament-event--senior-days u-mb-3"></div>
					<div class="lta-tournament-event--no-of-events u-mb-3"></div>
					<div class="lta-tournament-event--no-of-entries u-mb-3"></div>
					<div class="lta-tournament-event--no-of-days-worked u-mb-3"></div>
                </div>
            </div>
        `;
	}
	afterRender() {
		this.tournamentEventElement = SelectorEngine.findOne('.lta-tournament-event', this.containerEl);
		this.tournamentEventForm = SelectorEngine.findOne('.lta-tournament-event--form', this.tournamentEventElement);
		this.miniDays = SelectorEngine.findOne('.lta-tournament-event--mini-days', this.tournamentEventForm);
		this.juniorDays = SelectorEngine.findOne('.lta-tournament-event--junior-days', this.tournamentEventForm);
		this.openDays = SelectorEngine.findOne('.lta-tournament-event--open-days', this.tournamentEventForm);
		this.seniorDays = SelectorEngine.findOne('.lta-tournament-event--senior-days', this.tournamentEventForm);
		this.noOfEvents = SelectorEngine.findOne('.lta-tournament-event--no-of-events', this.tournamentEventForm);
		this.noOfEntries = SelectorEngine.findOne('.lta-tournament-event--no-of-entries', this.tournamentEventForm);
		this.noOfDaysWorked = SelectorEngine.findOne('.lta-tournament-event--no-of-days-worked', this.tournamentEventForm);
		// this.yourRole = SelectorEngine.findOne('.lta-tournament-event--your-role', this.tournamentEventForm);

		const eventInputObjects = [
			{
				inputElementData: this.miniDays,
				elementDataKey: 'miniDays'
			},
			{
				inputElementData: this.juniorDays,
				elementDataKey: 'juniorDays'
			},
			{
				inputElementData: this.openDays,
				elementDataKey: 'openDays'
			},
			{
				inputElementData: this.seniorDays,
				elementDataKey: 'seniorDays'
			},
			{
				inputElementData: this.noOfEvents,
				elementDataKey: 'noOfEvents'
			},
			{
				inputElementData: this.noOfEntries,
				elementDataKey: 'noOfEntries'
			},
			{
				inputElementData: this.noOfDaysWorked,
				elementDataKey: 'noOfDaysWorked'
			}
		];
		// const eventSelectObjects = [
		// 	{
		// 		selectElementData: this.yourRole,
		// 		elementDataKey: 'yourRole'
		// 	}
		// ];
		this.initInputObject(eventInputObjects);
		// this.initSelectObject(eventSelectObjects);
		this.data.value && this.fillEventForm(eventInputObjects);
	}

	fillEventForm(eventInputObjects) {
		for (const element of eventInputObjects) {
			element.inputElementData.querySelector('.lta-text-input').value = this.data.value[element.elementDataKey];
		}
	}

	initInputObject(eventObjects) {
		this.inputElementsObjects = [];
		for (const eventObject of eventObjects) {
			const inputFieldObject = new InputField(eventObject.inputElementData, {
				data: this.data.tournamentEventFormElement[eventObject.elementDataKey]
			});
			this.inputElementsObjects.push(inputFieldObject);
			inputFieldObject.onChange((dataObject) => {
				const valueObject = {};
				valueObject[eventObject.elementDataKey] = dataObject.value;
				this.value = {
					...this.value,
					...valueObject
				};
			});
		}
	}
	// initSelectObject(eventObjects) {
	// 	this.selectElementsObjects = [];
	// 	for (const eventObject of eventObjects) {
	// 		const selectFieldObject = new SelectComponent(eventObject.selectElementData, {
	// 			data: this.data.tournamentEventFormElement[eventObject.elementDataKey]
	// 		});
	// 		this.selectElementsObjects.push(selectFieldObject);
	// 		selectFieldObject.onChange((dataObject) => {
	// 			const valueObject = {};
	// 			valueObject[eventObject.elementDataKey] = dataObject.value;
	// 			this.value = {
	// 				...this.value,
	// 				...valueObject
	// 			};
	// 		});
	// 	}
	// }
	validate() {
		for (const inputElementsObject of this.inputElementsObjects) {
			inputElementsObject.validate();
		}
		// for (const selectElementsObject of this.selectElementsObjects) {
		// 	selectElementsObject.validate();
		// }
	}
}
export default TournamentEventForm;
